import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'

export default function ResumeRender(props) {
    const { setNodeData } = props;

    setNodeData({
      type: "resume",
      resume: true
    })

    return(
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{display: "flex", alignItems:'center', justifyContent:"center", flexDirection: "row"}}>
        <Typography>Resume task</Typography>
      </Grid>)
}